import React, { useState } from 'react'
import axios from 'axios'
import './NovoPed.css'
import InputMask from 'react-input-mask'

import brasao from '../../assets/brasilNav.png'

const processoInit = {
    criador: localStorage.nomeE,
    dataCriacao: new Date().toLocaleString(),
    resolucoes: [],
    infracoes: []
}

const NovoPed = () => {
    const [processo, setProcesso] = useState(processoInit)
    const [qtdForm, setForm] = useState({ qtdForm: 0 })
    const [qtdFormInfracoes, setFormInfracoes] = useState({ qtdFormInfracoes: 0 })

    const updateField = (e) => {
        const { name, value } = e.target
        setProcesso(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const save = (e) => {
        const url = '/api/ped/novoPed'
        axios.post(url, processo)
            .then(res => {
                alert("O Processo foi registrado com sucesso!")
                window.location = `/etica/documentosPed/${res.data._id}`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            });
    }

    const updateForms = (e) => {
        const { name } = e.target
        if (name === "menos") {
            setForm(prevState => ({
                ...prevState,
                qtdForm: qtdForm.qtdForm - 1
            }))
            setProcesso(prevState => {
                const updatedResolucoes = prevState.resolucoes.slice(0, prevState.resolucoes.length - 1)
                return {
                    ...prevState,
                    resolucoes: updatedResolucoes
                }
            })
        } else if (name === "mais") {
            setForm(prevState => ({
                ...prevState,
                qtdForm: qtdForm.qtdForm + 1
            }))
            setProcesso(prevState => {
                const updatedResolucoes = [...prevState.resolucoes, {}]
                return {
                    ...prevState,
                    resolucoes: updatedResolucoes
                }
            })
        }
    }    

    const updateFormsInfracoes = (e) => {
        const { name } = e.target
        if (name === "menos") {
            setFormInfracoes(prevState => ({
                ...prevState,
                qtdFormInfracoes: qtdFormInfracoes.qtdFormInfracoes - 1
            }))
            setProcesso(prevState => ({
                ...prevState,
                infracoes: prevState.infracoes.slice(0, prevState.infracoes.length - 1)
            }))
        } else if (name === "mais") {
            setFormInfracoes(prevState => ({
                ...prevState,
                qtdFormInfracoes: qtdFormInfracoes.qtdFormInfracoes + 1
            }))
            setProcesso(prevState => ({
                ...prevState,
                infracoes: [...prevState.infracoes, {}]
            }))
        }
    }    

    const updateResolucoes = (e) => {
        const { id, name, value } = e.target
        let novaResolucao = [...processo.resolucoes]
        novaResolucao[name][id] = value
        setForm(prevState => ({
            ...prevState,
            resolucoes: novaResolucao
        }))
    }
    
    const updateInfracoes = (e) => {
        const { id, name, value } = e.target
        let novaInfracao = [...processo.infracoes]
        novaInfracao[name][id] = value
        setForm(prevState => ({
            ...prevState,
            infracoes: novaInfracao
        }))
    }
    
    return (
        <React.Fragment>
            <img src={brasao} alt="Brasil" className='brasaoPed' />
            <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
            <div className="faixaVerde">
                <div className="formNovoPed">
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Número do PED</span>
                        <input type="text" className="inputNPed"
                            name="numeroPed"
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Estado</span>
                        <select className='inputNPed'
                            name="estado"
                            onChange={e => updateField(e)} >
                            <option value="" disabled selected></option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>
                    </div>
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Representante</span>
                        <input type="text" className="inputNPed"
                            name="representante"
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Número do PAF/PAD</span>
                        <input type="text" className="inputNPed"
                            name="numeroPaf"
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Representado</span>
                        <input type="text" className="inputNPed"
                            name="representado"
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Número Crefito</span>
                        <input type="text" className="inputNPed"
                            name="numeroCrefito"
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="formInfracoesNPed">
                        <span className='labelNovoPed'>Profissão</span>
                        <select className='inputNPed'
                            name="profissao"
                            onChange={e => updateField(e)} >
                            <option value="" disabled selected></option>
                            <option value="Fisioterapia">Fisioterapia</option>
                            <option value="Terapia Ocupacional">Terapia Ocupacional</option>
                        </select>
                    </div>
                    <div className='mt-5'>
                        <span className='labelNovoPed'>Resoluções Infrigidas</span>
                        <div className='addFormDiv'>
                            <button className='menosAddForm'
                                name="menos"
                                onClick={e => updateForms(e)}>-</button>
                            <input type="number" className='inputAddForm' value={qtdForm.qtdForm} />
                            <button className='maisAddForm'
                                name="mais"
                                onClick={e => updateForms(e)}>+</button>
                        </div>
                    </div>
                    {RenderForms()}
                    <div className='mt-5'>
                        <span className='labelNovoPed'>Infrações</span>
                        <div className='addFormDiv'>
                            <button className='menosAddForm'
                                name="menos"
                                onClick={e => updateFormsInfracoes(e)}>-</button>
                            <input type="number" className='inputAddForm' value={qtdFormInfracoes.qtdFormInfracoes} />
                            <button className='maisAddForm'
                                name="mais"
                                onClick={e => updateFormsInfracoes(e)}>+</button>
                        </div>
                    </div>
                    {RenderFormsInfracoes()}
                    {/* <div className="formInfracoesNPed">
                        <span className='labelNovoPed'>Infrações</span>
                        <textarea className="infracoesNPed"
                            name="infracoes"
                            onChange={e => updateField(e)} ></textarea>
                    </div> */}
                    <button className="botaoNPed" onClick={e => save(e)}>ADICIONAR</button>
                </div>
            </div>
        </React.Fragment>
    )

    function RenderForms() {
        let forms = []
        for (let n = 0; n < qtdForm.qtdForm; n++) {
            forms.push(
                <div className="nPedResolucoesDiv" key={n}>
                    <InputMask type="text" className="inputNPedResolucao" placeholder='Resolução'
                        mask="999/9999"
                        name={n}
                        id="resolucao"
                        onChange={e => updateResolucoes(e)} />
                </div>
            )
        }
        return forms
    }

    function RenderFormsInfracoes() {
        let forms = []
        for (let n = 0; n < qtdFormInfracoes.qtdFormInfracoes; n++) {
            if (processo.profissao === "Fisioterapia") {
                forms.push(
                    <div className="formInfracoesNPed">
                        <select className='inputNPed'
                            name={n}
                            id="infracao"
                            onChange={e => updateInfracoes(e)} >
                            <option value="" disabled selected></option>
                            <option value="Estágio não obrigatório do curso de Fisioterapia em quantitativo acima do permitido na Resolução 432/2013">Estágio não obrigatório do curso de Fisioterapia em quantitativo acima do permitido na Resolução 432/2013</option>
                            <option value="Estágio obrigatório de acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)">Estágio obrigatório de acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)</option>
                            <option value="Exercício ilegal da profissão de fisioterapeuta">Exercício ilegal da profissão de fisioterapeuta</option>
                            <option value="Prática de atividades da Fisioterapia por pessoa não habilitada">Prática de atividades da Fisioterapia por pessoa não habilitada</option>
                            <option value="Delegação de função privativa do profissional fisioterapeuta">Delegação de função privativa do profissional fisioterapeuta</option>
                            <option value="Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço">Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço</option>
                            <option value="Ausência do responsável técnico de Fisioterapia">Ausência do responsável técnico de Fisioterapia</option>
                            <option value="Profissional com Licença Temporária de Fisioterapia vencida">Profissional com Licença Temporária de Fisioterapia vencida</option>
                            <option value="Falta de registro das atividades assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo fisioterapeuta, da guarda e do seu descarte. (Responsável Técnico)">Falta de registro das atividades assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo fisioterapeuta, da guarda e do seu descarte. (Responsável Técnico)</option>
                            <option value="Descumprimento a RDC-07">Descumprimento a RDC-07</option>
                            <option value="Falta de registro de consultório">Falta de registro de consultório</option>
                            <option value="Débitos com obrigações pecuniárias">Débitos com obrigações pecuniárias</option>
                            <option value="Descumprimento dos parâmetros assistenciais fisioterapêuticos">Descumprimento dos parâmetros assistenciais fisioterapêuticos</option>
                            <option value="Descumprimento da Portaria CREFITO-1 Nº 046/2020">Descumprimento da Portaria CREFITO-1 Nº 046/2020</option>
                            <option value="Descumprimento da legislação referente ao registro em prontuário dos fisioterapeutas">Descumprimento da legislação referente ao registro em prontuário dos fisioterapeutas</option>
                            <option value="Publicidade irregular - exposição de pacientes">Publicidade irregular - exposição de pacientes</option>
                            <option value="Publicidade irregular">Publicidade irregular</option>
                            <option value="Falta de Registro de Pessoa Jurídica junto ao CREFITO-1">Falta de Registro de Pessoa Jurídica junto ao CREFITO-1</option>
                            <option value="Profissional sem registro de inscrição secundária">Profissional sem registro de inscrição secundária</option>
                            <option value="Desvio de circunscrição, pois o fisioterapeuta não realizou a transferência">Desvio de circunscrição, pois o fisioterapeuta não realizou a transferência</option>
                            <option value="Falta de cadastro do estabelecimento fiscalizado de Fisioterapia">Falta de cadastro do estabelecimento fiscalizado de Fisioterapia</option>
                            <option value="Outros">Outros</option>
                        </select>
                    </div>
                )
            }
            else if (processo.profissao === "Terapia Ocupacional") {
                forms.push(
                    <div className="formInfracoesNPed">
                        <select className='inputNPed'
                            name={n}
                            id="infracao"
                            onChange={e => updateInfracoes(e)} >
                            <option value="" disabled selected></option>
                            <option value="Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na Resolução COFFITO 452/2015">Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na Resolução COFFITO 452/2015</option>
                            <option value="Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)">Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)</option>
                            <option value="Exercício ilegal da profissão de terapeuta ocupacional">Exercício ilegal da profissão de terapeuta ocupacional</option>
                            <option value="Prática de atividades da Terapia Ocupacional por pessoa não habilitada">Prática de atividades da Terapia Ocupacional por pessoa não habilitada</option>
                            <option value="Delegação de função privativa do profissional terapeuta ocupacional">Delegação de função privativa do profissional terapeuta ocupacional</option>
                            <option value="Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço">Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço</option>
                            <option value="Ausência do responsável técnico de Terapia Ocupacional">Ausência do responsável técnico de Terapia Ocupacional</option>
                            <option value="Profissional com Licença Temporária de Terapia Ocupacional vencida">Profissional com Licença Temporária de Terapia Ocupacional vencida</option>
                            <option value="Falta de registro das atividades assistenciais terapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e do seu descarte. (Responsável Técnico)">Falta de registro das atividades assistenciais terapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e do seu descarte. (Responsável Técnico)</option>
                            <option value="Falta de registro de consultório">Falta de registro de consultório</option>
                            <option value="Débitos com obrigações pecuniárias">Débitos com obrigações pecuniárias</option>
                            <option value="Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico">Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico</option>
                            <option value="Descumprimento da Portaria CREFITO-1 Nº 046/2020">Descumprimento da Portaria CREFITO-1 Nº 046/2020</option>
                            <option value="Descumprimento da legislação referente ao registro em prontuário dos terapeutas ocupacionais">Descumprimento da legislação referente ao registro em prontuário dos terapeutas ocupacionais</option>
                            <option value="Publicidade irregular - exposição de pacientes">Publicidade irregular - exposição de pacientes</option>
                            <option value="Publicidade irregular">Publicidade irregular</option>
                            <option value="Falta de Registro de Pessoa Jurídica junto ao CREFITO-1">Falta de Registro de Pessoa Jurídica junto ao CREFITO-1</option>
                            <option value="Profissional sem registro de inscrição secundária">Profissional sem registro de inscrição secundária</option>
                            <option value="Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência">Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência</option>
                            <option value="Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional">Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional</option>
                            <option value="Outros">Outros</option>
                        </select>
                    </div>
                )
            }
            else {
                forms.push(
                    <div>Escolha a profissão!</div>
                )
            }

            if (processo.infracoes[n] && processo.infracoes[n].infracao === "Outros") {
                forms.push(
                    <input type="text" className="inputNPed" style={{marginTop: "2vh"}}
                        name={n}
                        id="outraInfracao"
                        onChange={e => updateInfracoes(e)} />
                )
            }
        }
        return forms
    }
}

export default NovoPed

